/**
 * @generated SignedSource<<80647f7e90ea51c0f2747b189b579102>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type morningStudioArticleFooterContent$data = {
  readonly entityUuid: string;
  readonly topics: ReadonlyArray<{
    readonly entityUuid: string;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "morningStudioArticleFooterContent";
};
export type morningStudioArticleFooterContent$key = {
  readonly " $data"?: morningStudioArticleFooterContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"morningStudioArticleFooterContent">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityUuid",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "morningStudioArticleFooterContent",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Topic",
      "kind": "LinkedField",
      "name": "topics",
      "plural": true,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};
})();

(node as any).hash = "0703ac83d8a872b3a70df512368f7ba8";

export default node;
